CommentCollection = require("collections/comments")
PAGE_SIZE = 10
DEFAULT_COMMENT_LENGTH = 140
class SocialLearningView extends Backbone.View
  templates:
    list: require("templates/components/engine/social-learning-comments")

  events:
    "open": "open"
    "exit": "exit"
    "iostap": "exit"

    # Comment actions
    "iostap .comment-like": "likeComment"
    "iostap .comment-flag": "flagComment"
    "iostap .comment-delete": "deleteComment"
    "iostap .comment": "toggleComment"

    # Input actions
    "focus #social-view-input-text": "onFocus"
    "iostap #social-view-start": "openInput"
    "iostap #social-view-input-confirm": "addComment"
    "iostap #social-view-input-cancel": "closeInput"
    "input #social-view-input-text": "onChangeText"

  initialize: ->
    @eventSuffix = ""

    # TODO: Fix social-learning rendering incorrect comments from previous peer-authoring slide on refresh
    # @listenTo Backbone.Events, "subscribe:event:comment-loaded", =>
      # @renderComments()

    @listenTo Backbone.Events, "open-social-learning", ({ slide, peerAuthoring, contentId }) =>
      @open(slide, undefined, peerAuthoring, contentId)

    return unless @el
    if window.navigator.userAgent.match(/iP(ad|hone|od)/)
      @el.classList.add("is-ios")

    @elements =
      list: @el.querySelector("#social-view-messages-list")
      input: @el.querySelector("#social-view-input-text")
      title: @el.querySelector("#social-view-input-title")
      limit: @el.querySelector("#social-view-input-limit")
      count: @el.querySelector("#social-view-input-slide-count")

  open: (@slide, comments, @peerAuthoring, @contentId) ->
    # Use social learning for peer authoring
    if @peerAuthoring
      @eventSuffix = "-pa"
    else
      @eventSuffix = ""

    # Peer authoring sends undefined
    if not @peerAuthoring and comments.length < PAGE_SIZE
      @isNoMoreComments = true
    else
      @isNoMoreComments = false

    @id = @slide.id
    @comments = new CommentCollection()
    @comments.add(comments) if comments
    @listenTo @comments, "change add remove", @renderComments
    @renderComments()
    @renderSlideData()

    # If we are using this view for peer authoring then use get comments
    if @peerAuthoring
      @getMoreComments()

    @el.classList.add("visible")

    @trigger("open")

    @elements.list.addEventListener("scroll", this)

    @showtimeout = window.setTimeout (=>
      @active = true
      @el.classList.add("active")
    ), 300

  # update comments
  updateComments: (comments, hasMore) ->
    if hasMore
      @isNoMoreComments = false
    if @comments
      @comments.set(comments)

  renderComments: ->
    unless @comments
      return
    comments = @comments.toJSON()
    rx = /^(\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62(?:\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67|\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74)\uDB40\uDC7F|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC68(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83D\uDC68|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|[\u2695\u2696\u2708]\uFE0F|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92])|(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2695\u2696\u2708]\uFE0F|(?:\uD83C[\uDFFB-\uDFFF])\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]))|\uD83D\uDC69\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92])|\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66|(?:\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2695\u2696\u2708]|(?:(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)\uFE0F|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF])\u200D[\u2640\u2642]|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDD6-\uDDDD])(?:(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|\u200D[\u2640\u2642])|\uD83D\uDC69\u200D[\u2695\u2696\u2708])\uFE0F|\uD83D\uDC69\u200D\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D\uDC68(?:\u200D(?:(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D[\uDC66\uDC67])|\uD83C[\uDFFB-\uDFFF])|\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08|\uD83D\uDC69\u200D\uD83D\uDC67|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92])|\uD83D\uDC69\u200D\uD83D\uDC66|\uD83C\uDDF4\uD83C\uDDF2|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF6\uD83C\uDDE6|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])|\uD83C\uDDFC(?:\uD83C[\uDDEB\uDDF8])|\uD83C\uDDEB(?:\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7])|\uD83C\uDDE9(?:\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF])|\uD83C\uDDE7(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF])|\uD83C\uDDF1(?:\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE])|\uD83C\uDDFE(?:\uD83C[\uDDEA\uDDF9])|\uD83C\uDDF9(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF])|\uD83C\uDDF5(?:\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE])|\uD83C\uDDEF(?:\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5])|\uD83C\uDDED(?:\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA])|\uD83C\uDDEE(?:\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9])|\uD83C\uDDFB(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA])|\uD83C\uDDEC(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE])|\uD83C\uDDF7(?:\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC])|\uD83C\uDDEA(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA])|\uD83C\uDDFA(?:\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF])|\uD83C\uDDE8(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF])|\uD83C\uDDE6(?:\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF])|[#\*0-9]\uFE0F\u20E3|\uD83C\uDDF8(?:\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF])|\uD83C\uDDFF(?:\uD83C[\uDDE6\uDDF2\uDDFC])|\uD83C\uDDF0(?:\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF])|\uD83C\uDDF3(?:\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF])|\uD83C\uDDF2(?:\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF])|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u270A-\u270D]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC70\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDCAA\uDD74\uDD7A\uDD90\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD36\uDDD1-\uDDD5])(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u26F9\u270A-\u270D]|\uD83C[\uDF85\uDFC2-\uDFC4\uDFC7\uDFCA-\uDFCC]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66-\uDC69\uDC6E\uDC70-\uDC78\uDC7C\uDC81-\uDC83\uDC85-\uDC87\uDCAA\uDD74\uDD75\uDD7A\uDD90\uDD95\uDD96\uDE45-\uDE47\uDE4B-\uDE4F\uDEA3\uDEB4-\uDEB6\uDEC0\uDECC]|\uD83E[\uDD18-\uDD1C\uDD1E\uDD1F\uDD26\uDD30-\uDD39\uDD3D\uDD3E\uDDD1-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])?|(?:[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u270A\u270B\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF93\uDFA0-\uDFCA\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF4\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC3E\uDC40\uDC42-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDD7A\uDD95\uDD96\uDDA4\uDDFB-\uDE4F\uDE80-\uDEC5\uDECC\uDED0-\uDED2\uDEEB\uDEEC\uDEF4-\uDEF8]|\uD83E[\uDD10-\uDD3A\uDD3C-\uDD3E\uDD40-\uDD45\uDD47-\uDD4C\uDD50-\uDD6B\uDD80-\uDD97\uDDC0\uDDD0-\uDDE6])|(?:[#\*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u2660\u2663\u2665\u2666\u2668\u267B\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEF8]|\uD83E[\uDD10-\uDD3A\uDD3C-\uDD3E\uDD40-\uDD45\uDD47-\uDD4C\uDD50-\uDD6B\uDD80-\uDD97\uDDC0\uDDD0-\uDDE6])\uFE0F)+$/
    isEmoji  = (msg) -> msg.length < 16 and msg.match(rx)

    @isLoading = false
    @el.classList.remove("is-loading")

    commentThreadHtml = @templates.list({
      comments, isEmoji,
      peerAuthoring: @peerAuthoring
      isNoMoreComments: @isNoMoreComments
    })

    $(@elements.list).html(commentThreadHtml)

  renderSlideData: ->
    if @slide.lesson?.configuration
      $(@elements.title).html(@slide.lesson.configuration.title or "")
      $(@elements.count).html([
        @getCurrentPage() + 1
        @slide.lesson.configuration.slides.length
      ].join(" / "))

      limit = @slide.options.data.socialLearning?.maxResponseLength || 140
      $(@elements.limit).html(limit)
      @el.classList.toggle("has-limit", limit > 0)

  exit: (e) ->
    if e?.target is @el or not e?.target
      window.clearTimeout @showtimeout
      document.activeElement.blur() if document.activeElement
      @active = false

      @elements.input.value = ""

      @elements.list.removeEventListener("scroll", this)
      @el.classList.remove("active")
      @el.classList.remove("visible")
      @trigger("exit")
      Backbone.Events.trigger "social-learning:exit"

  onBlur: ->
    return unless @active
    @exit()

  toggleComment: (e) ->
    el = e.currentTarget
    el.classList.toggle("is-selected")

    if el isnt @elements.activeComment
      @elements.activeComment?.classList.remove("is-selected")

    if el.classList.contains("is-selected")
      @elements.activeComment = el
    else
      delete @elements.activeComment

  likeComment: (e) ->
    e.stopImmediatePropagation()
    like = @comments.like(@id, e.currentTarget.dataset.id)
    if like
      Application.publish("event:like-comment#{@eventSuffix}") {slideId: @id, commentId: e.currentTarget.dataset.id, @contentId}
    else
      Application.publish("event:unlike-comment#{@eventSuffix}") {slideId: @id, commentId: e.currentTarget.dataset.id, @contentId}

  flagComment: (e) ->
    e.stopImmediatePropagation()
    updated = @comments.flag(e.currentTarget.dataset.id)
    if updated
      Application.publish("event:flag-comment#{@eventSuffix}") {slideId: @id, commentId: e.currentTarget.dataset.id, @contentId}

  deleteComment: (e) ->
    # TODO: show loading and disable loading when receiving a comment
    e.stopImmediatePropagation()
    Application.publish("event:delete-comment#{@eventSuffix}") {slideId: @id, commentId: e.currentTarget.dataset.id, @contentId}

  openInput: (e) ->
    @el.classList.add("is-input-mode")
    @elements.input.focus()

  onFocus: ->
    window.setTimeout (->
      Application.publish("event:scroll-to-top#{@eventSuffix}")()
    ), 400

  handleEvent: (e) ->
    switch e.type
      when "scroll" then @onScroll(e)

  onScroll: (e) ->
    if e.target.scrollTop >= e.target.scrollHeight - e.target.offsetHeight
      @getMoreComments()
    else if e.target.scrollTop > 0
      @elements.list.firstChild.style.transform = "translate3d(0,0,0)"
      @elements.list.firstChild.offsetHeight
      @elements.list.firstChild.style.transform = ""

  closeInput: ->
    @el.classList.remove("is-input-mode")
    @elements.input.blur()

  addComment: ->
    message = @elements.input.value
    maxLength = @slide.options?.data?.socialLearning?.maxResponseLength or 5000

    if @comment?.length >= PAGE_SIZE - 1
      @isNoMoreComments = false

    if message and message.length <= maxLength
      @elements.input.value = ""
      @updateCharacterCount()
      @closeInput()
      Application.publish("event:add-comment#{@eventSuffix}") {message, slideId:@id, @contentId}
    else
      # todo: indicate comment over size in view
      console.log "character too many! expect #{maxLength} got: #{message.length} "

  getMoreComments: ->
    if not @isLoading and not @isNoMoreComments
      @isLoading = true
      @el.classList.add("is-loading")
      Application.publish("event:more-comment#{@eventSuffix}") {slideId: @id, @contentId}

  onChangeText: (e) ->
    return unless @active
    @updateCharacterCount()

  updateCharacterCount: () ->
    value = @elements.input.value
    limit = @slide.options.data.socialLearning?.maxResponseLength || DEFAULT_COMMENT_LENGTH

    if limit > 0
      $(@elements.limit).html(limit - value.length)
      @el.classList.toggle("over-limit", limit - value.length < 0)
    else
      @el.classList.remove("over-limit")

module.exports = SocialLearningView
